export default {
  '0': 'pink',
  '1': 'blue',
  '2': 'green',
  '3': 'orange',
}